'use client';
import { useLocale } from 'next-intl';
import StoresCarousel from '@/components/carousel/stores-carousel';
import { IStore } from '@/types/stores';

type CarouselSection = {
  slides: IStore[];
  title?: string;
  englishName: string;
  arabicName: string;
};
const NearByStoresSection = (props: CarouselSection) => {
  const localActive = useLocale();
  return (
    props.slides.length > 0 && (
      <StoresCarousel
        currentLang={localActive as 'en' | 'ar'}
        slides={props.slides}
        arabicName={props.arabicName}
        englishName={props.englishName}
      />
    )
  );
};

export default NearByStoresSection;
